import CONCIEN from '../../assets/images/groups/CONCIEN Y PREV.png'
import SEGFI from '../../assets/images/groups/SEG FISI.png'
import SEGSAL from '../../assets/images/groups/SEG Y SALUD.png'
import SERVCLI from '../../assets/images/groups/SERV AL CLI.png'
import SSTAER from '../../assets/images/groups/SST AEROP.png'
import STTINS from '../../assets/images/groups/SST INSTALA.png'

export const GROUP_IMAGES = [
    {
        name:'CONCIENTIZACIÓN Y PREVENCIÓN',
        image: CONCIEN
    },
    {
        name:'SEGURIDAD FÍSICA',
        image: SEGFI
    },
    {
        name:'SEGURIDAD AVSEC',
        image: SEGSAL
    },
    {
        name:'SERVICIO AL CLIENTE',
        image: SERVCLI
    },
    {
        name:'SST AEROPORTUARIO',
        image: SSTAER
    },
    {
        name:'SST INSTALACIONES',
        image: STTINS
    }
]